<script setup>
import { useAccreditation } from '@/composables/useAccreditation'
import { useRoute } from 'vue-router'

definePage({
  meta: {
    layout: 'default',
    action: 'self-assess',
    subject: 'Accreditation',
  },
})

const route = useRoute('accreditation-self-assessment-result-id')
const resultId = computed(() => route.params.resultId)

const { sessionTree, progress, loading, fetchSessionTree, fetchProgress } = useAccreditation()

const selectedNode = ref(null)

const load = async () => {
  await Promise.all([fetchSessionTree(resultId.value), fetchProgress(resultId.value)])
}

onMounted(load)

function onSelect(node) {
  if (node.tipe === 'ep') selectedNode.value = node
}

async function onSaved() {
  await load()

  // Sinkronkan panel skor yang sedang terbuka dengan data terbaru (cari
  // ulang node yang sama dari tree yang baru saja di-fetch).
  if (selectedNode.value) {
    const found = findNode(sessionTree.value, selectedNode.value.id)
    if (found) selectedNode.value = found
  }
}

function findNode(nodes, id) {
  for (const n of nodes) {
    if (n.id === id) return n
    const found = findNode(n.children ?? [], id)
    if (found) return found
  }

  return null
}
</script>

<template>
  <div>
    <VRow class="mb-4">
      <VCol cols="12">
        <h4 class="text-h4 font-weight-bold">
          Self-Assessment Akreditasi
        </h4>
        <p class="text-body-2 text-medium-emphasis mb-0">
          Sesi #{{ resultId }} — isi skor per EP, lampirkan bukti, atau ajukan TDD (§9.8)
        </p>
      </VCol>
    </VRow>

    <VCard class="mb-4">
      <VCardTitle class="pa-6 pb-0">
        Progress
      </VCardTitle>
      <VCardText class="pa-6">
        <ProgressGauge
          v-for="bab in progress"
          :key="bab.node_id"
          :kode="bab.kode"
          :judul="bab.judul"
          :total-ep="bab.total_ep"
          :ep-terisi="bab.ep_terisi"
          :persentase="bab.persentase"
        />
      </VCardText>
    </VCard>

    <VRow>
      <VCol
        cols="12"
        md="5"
      >
        <VCard>
          <VCardTitle class="pa-6 pb-0">
            Standar
          </VCardTitle>
          <VCardText class="pa-6">
            <VProgressLinear
              v-if="loading"
              indeterminate
              color="primary"
              class="mb-3"
            />
            <StandardTree
              :nodes="sessionTree"
              show-scores
              :selected-id="selectedNode?.id"
              @select="onSelect"
            />
          </VCardText>
        </VCard>
      </VCol>
      <VCol
        cols="12"
        md="7"
      >
        <EpScoreCard
          v-if="selectedNode"
          :result-id="resultId"
          :node="selectedNode"
          @saved="onSaved"
        />
        <VCard v-else>
          <VCardText class="text-center py-10 text-medium-emphasis">
            Pilih Elemen Penilaian di sebelah kiri untuk mengisi skor.
          </VCardText>
        </VCard>
      </VCol>
    </VRow>
  </div>
</template>
